import styled, { css } from 'styled-components';
import { breakpointMax } from '../../../foundation/theme/breakpoints.utils';
import { getWhiteColor } from '../../../foundation/theme/palette.utils';
import { getRadius, getShadow } from '../../../foundation/theme/shape.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { CARD_IMAGE_MAX_HEIGHT, CARD_IMAGE_MAX_HEIGHT_MOBILE, CARD_IMAGE_MAX_WIDTH, CARD_IMAGE_MAX_WIDTH_MOBILE } from './Card.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const CardContentActions = styled.div `
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: ${getSpace('s')};
  justify-content: flex-start;
`;
export const CardContent = styled.div `
  ${({ selected, hasImage }) => css `
    background-color: ${selected
    ? tokens.colors.emerald[100].value
    : getWhiteColor()};
    display: flex;
    flex-direction: column;
    border-left: ${hasImage
    ? `1px solid ${tokens.colors.midnight[200].value}`
    : `0`};
    flex: 1 1 auto;
    justify-content: space-between;
    padding: ${getSpace('2xl')};
  `}
`;
export const CardFlag = styled.div `
  left: -4px;
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  z-index: 1;
`;
export const CardNoImage = styled.div `
  ${({ theme }) => css `
    align-items: center;
    background-color: ${tokens.colors.midnight[100].value};
    color: ${tokens.colors.midnight[200].value};
    display: inline-flex;
    flex-shrink: 0;
    justify-content: center;
    width: ${CARD_IMAGE_MAX_WIDTH}px;

    ${breakpointMax({
    breakpoint: 'm',
    rules: css `
        display: none;
      `,
    theme
})}
  `}
`;
export const CardRoot = styled.div `
  ${({ theme, selected }) => css `
    border: 1px solid ${tokens.colors.midnight[selected ? 500 : 200].value};
    box-shadow: ${getShadow({ mode: 'light', theme, variant: 'm' })};
    border-radius: ${getRadius(theme, 'm')};
    display: flex;
    min-height: ${CARD_IMAGE_MAX_HEIGHT}px;
    margin-bottom: ${getSpace('4xl')};
    overflow: hidden;

    ${breakpointMax({
    breakpoint: 'm',
    rules: css `
        flex-direction: column;
        height: auto;
      `,
    theme
})}
  `}
`;
export const CardWithImage = styled.div `
  ${({ isCover, theme, url }) => css `
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${url});
    flex-shrink: 0;
    height: ${CARD_IMAGE_MAX_HEIGHT}px;
    width: ${CARD_IMAGE_MAX_WIDTH}px;

    ${isCover && `background-size: cover;`}

    ${breakpointMax({
    breakpoint: 'm',
    rules: css `
        border-right: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: ${getSpace('3xl')};
        height: ${CARD_IMAGE_MAX_HEIGHT_MOBILE}px;
        width: ${CARD_IMAGE_MAX_WIDTH_MOBILE}px;
      `,
    theme
})}
  `}
`;
export const CardWrapper = styled.div `
  position: relative;
`;
//# sourceMappingURL=Card.styled.js.map